import { websocketService } from '@services/websocketService';
import { setCredentials, logout } from '@features/auth/authSlice';
export const websocketMiddleware = () => (next) => (action) => {
    // 登录成功时连接WebSocket
    if (setCredentials.match(action)) {
        const { token } = action.payload;
        websocketService.connect(token);
        websocketService.requestNotificationPermission();
    }
    // 登出时断开WebSocket
    if (logout.match(action)) {
        websocketService.disconnect();
    }
    return next(action);
};
